/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { TaggingService, UtilityService } from '@shared/data-access/services';

import { Cta } from '@dcsg-ngx-ecommerce/engage';
import { HOME_CONSTANTS } from '../../app.constants';
import { chain } from '@core/chain';

@Component({
	selector: 'home-cta',
	templateUrl: './cta.component.html',
	styleUrl: './cta.component.scss',
	standalone: false
})
export class CtaComponent implements OnInit {
	@Input() data: Cta;
	@Input() addlData: any;
	@Input() altText: string;
	@Input() tagSectionNum: string;
	@Input() widgetTypeTag: string;
	@Input() ctaIndex: number;
	@Input() parentIndex: number;
	@Input() title: string;
	public targetService: any;
	public isGGStaticPage: boolean;
	public ggStaticColors = HOME_CONSTANTS.ggStaticColors;
	style: string;

	constructor(
		public taggingService: TaggingService,
		private utilityService: UtilityService
	) {
		this.targetService = this.utilityService.target;
	}

	ngOnInit() {
		this.isGGStaticPage = this.utilityService.ggStaticPage(this.addlData.isStaticPage);
	}

	createTag(ctaText: string) {
		return this.taggingService.createTag(
			this.addlData.tagSectionNum,
			this.addlData.widgetTypeTag,
			this.parentIndex,
			this.ctaIndex,
			ctaText,
			this.altText,
			this.title,
			false,
			'hp'
		);
	}

	ctaIcon() {
		let icon = 'arrow_forward';
		icon = chain.chainIdentifierAbbr === 'gg' ? 'chevron_right' : icon;
		icon = chain.chainIdentifierAbbr === 'pl' ? 'pl_arrow_forward' : icon;
		return icon;
	}
}
